import styled from 'styled-components';
import { respondTo } from '../../../../common/styles/mixins';
import * as variables from '../../../../common/styles/variables';
import * as colors from '../../../../common/styles/colors';

export const ChartsWrapper = styled.div`
  .dropdown__list {
    a {
      background-color: ${colors.white};
      color: ${colors.oxfordBlue};

      &:hover {
        background-color: ${({ theme }) => theme.primary.bg};
        color: ${colors.white};
      }
    }
  }

  .legend {
    ${respondTo.desktop`
      padding-left: 120px;
    `};
  }
`;

export const SidebarMobileWrapper = styled.div`
  display: block;
  ${respondTo.tablet`
    display: none;
  `};

  .monthdaybtn {
    margin-top: 15px;
  }

  .dropdown__list {
    a {
      display: table;
      background-color: ${({ theme }) => theme.primary.bg};
      color: ${colors.white};
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const SidebarWrapper = styled.div`
  display: none;
  ${respondTo.tablet`
    display: block
  `};

  .monthdaybtn {
    display: block;
    margin-top: 0px;
    margin-bottom: 5px;
    width: 100%;

    svg {
      margin-top: -5px;
    }
  }

  .sidebar-section {
    .filter-title {
      font-size: 16px;
      text-align: center;
      color: ${({ theme }) => theme.primary.color};
      margin: 0;

      ${respondTo.tablet`
        text-align: left;
      `}
    }

    .mpan-item {
      min-width: 200px;
      max-width: 300px;
    }
  }
`;
